var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrammar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6201:1062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.17 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V6.83C18 6.3 17.79 5.79 17.41 5.42L12.58 0.59C12.21 0.21 11.7 0 11.17 0ZM5 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14H5C4.45 14 4 13.55 4 13C4 12.45 4.45 12 5 12ZM5 8H13C13.55 8 14 8.45 14 9C14 9.55 13.55 10 13 10H5C4.45 10 4 9.55 4 9C4 8.45 4.45 8 5 8ZM5 4H10C10.55 4 11 4.45 11 5C11 5.55 10.55 6 10 6H5C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3459 18.3203L20.1994 18.1735H19.992H19.8776C20.725 16.9113 21.1251 15.3258 20.8457 13.6577L20.8455 13.657C20.3954 10.9948 18.1797 8.8742 15.4971 8.54832C11.4533 8.05148 8.0594 11.4571 8.54657 15.4973L8.54662 15.4977C8.87239 18.1803 10.9933 20.3959 13.6559 20.846L13.6566 20.8461C15.3248 21.1255 16.9106 20.7254 18.1728 19.8781V19.9925V20.1999L18.3197 20.3465L22.0657 24.0833C22.6215 24.639 23.5185 24.639 24.0743 24.0833L24.0831 24.0745C24.639 23.5187 24.639 22.6217 24.0831 22.0659L20.3459 18.3203ZM14.7154 18.1735C12.8017 18.1735 11.2579 16.6298 11.2579 14.7164C11.2579 12.803 12.8017 11.2593 14.7154 11.2593C16.6291 11.2593 18.1728 12.803 18.1728 14.7164C18.1728 16.6298 16.6291 18.1735 14.7154 18.1735Z",
    fill: "#858585",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18C16.433 18 18 16.433 18 14.5C18 12.567 16.433 11 14.5 11C12.567 11 11 12.567 11 14.5C11 16.433 12.567 18 14.5 18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6201:1062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/grammar.2609b4827b3515f1a1bd73ef1b8caf73.svg";
export { ForwardRef as ReactComponent };